export function getLocalIsoDate(date: Date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getLocalIsoDateFromTimestamp(timestamp?: string | null) {
  if (!timestamp) {
    return undefined;
  }
  const parsed = new Date(timestamp);
  if (Number.isNaN(parsed.valueOf())) {
    return undefined;
  }
  return getLocalIsoDate(parsed);
}
